// demandeId is a queryparam in the current url
import { getUrlParam } from './navigation.utils';

export const getActiveDemandeId = () => getUrlParam('demandeId');
